import React, { useEffect, useState } from 'react'
import { FieldArray } from 'react-final-form-arrays'
import { bool, func, object, shape, string } from 'prop-types';
import css from './FieldCheckboxGroupWithQuantity.module.css';
import { FieldNumberInput, FieldCheckbox, FieldQuantityInput } from '../../components';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';

const FieldCheckboxGroupWithQuantity = (props) => {

  const {
    arrayName,
    options,
    optionLabelClassName,
    rootClassName,
    quantityClassName,
    className,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <FieldArray name={arrayName}>
        {(fieldsProps) => {
          const { fields } = fieldsProps;

          const textClassName = optionLabelClassName;
          const textClassNameMaybe = textClassName ? { textClassName } : {};

          return options.map((name, index) => {

            return (
              <div key={options[index]?.key} className={css.item}>
                <FieldCheckbox
                  id={`${arrayName}.${[index]}.option`}
                  name={`${arrayName}.${[index]}.option`}
                  label={options[index].label}
                  value={options[index].key}
                  {...textClassNameMaybe}
                />

                {fields?.value &&
                  fields?.value[index] &&
                  fields?.value[index]?.option &&
                  !isEmpty(fields?.value[index]?.option) &&
                  <FieldQuantityInput
                    id={`${arrayName}.${[index]}.quantity`}
                    name={`${arrayName}.${[index]}.quantity`}
                    type='number'
                    min={1}
                    max={options[index].quantity}
                    initialValue={fields.value[index].quantity || 1}
                    className={quantityClassName}
                  />
                }
              </div>
            )
          })
        }
        }
      </FieldArray>
    </div>
  )
}

export default FieldCheckboxGroupWithQuantity;
